/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React from 'react';
import * as PropTypes from 'prop-types';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import NxFontAwesomeIcon from '../NxFontAwesomeIcon/NxFontAwesomeIcon';
import './NxLoadingSpinner.scss';
var NxLoadingSpinner = function NxLoadingSpinner(_a) {
    var children = _a.children;
    return (React.createElement("div", { role: "status", className: "nx-loading-spinner" },
        React.createElement(NxFontAwesomeIcon, { icon: faCircleNotch, className: "fa-spin nx-loading-spinner__icon" }),
        React.createElement("span", null, children || 'Loading…')));
};
NxLoadingSpinner.propTypes = {
    children: PropTypes.node
};
export default NxLoadingSpinner;
//# sourceMappingURL=NxLoadingSpinner.js.map